import { Backdrop, CircularProgress } from "@mui/material";

export default function Loader({ isOpen, size, backdropColor, backdropSx }) {
  if (!isOpen) {
    return <></>;
  }

  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 9999,
        position: "fixed",
        backgroundColor: backdropColor || "rgba(0,0,0,0.5)",
        ...backdropSx,
      }}
      open={true}
    >
      <CircularProgress
        size={size || 36}
        sx={{
          top: -6,
          left: -6,
          zIndex: 1,
          color: "#FF851B",
        }}
      />
    </Backdrop>
  );
}
